import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'

export const AddProteinPaintedDoorSurveyTracking: React.FC = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch({
      type: actionTypes.TRACKING,
      trackingData: {
        actionType: 'modal_popup',
        popup_name: 'add_protein_survey',
      },
    })
  }, [dispatch])

  return null
}
